import axios from 'axios';

export function sendTrackingEvent(name, properties){
    return axios.post(`/users/me/crisp-event`, {text: name, data: properties});
}